import React from "react";
import styled from "@emotion/styled";
import Timeline from "./timeline";

interface Props {
  theme: number;
}

export const Education: React.FC<Props> = (props) => {
  return (
    <EducationContainer theme={props.theme}>
      <div>Born in 2003.</div>
      <Timeline theme={props.theme} />
      <div>Present</div>
    </EducationContainer>
  );
};

const EducationContainer = styled("div")<Props>(({ theme }) => ({
  // width: "90vw",
  height: "100vh",
  display: "grid",
  justifyItems: "center",
  paddingLeft: "5%",
}));
